@if (content$ | async; as content) {
  <div>
    <div class="cancel-container" [class.cancel-container-transparent]="isTransparent">
      <c11n-button
        [variant]="quitButtonVariant"
        [iconName]="isTransparent ? 'remove' : ''"
        [iconPosition]="isTransparent ? 'trailing' : ''"
        [labelText]="labelText"
        [fullWidth]="!isTransparent"
        [size]="isTransparent ? 'small' : ''"
        (clickEvent)="openModal()">
      </c11n-button>
    </div>
    <c11n-modal-dialog
      #quitModal modalId="quit"
      [headingText]="content.modalHeader"
      [maxWidth]="isTransparent ? 660 : 500"
      (closeEvent)="closeQuitModalIcon()">
      <div c11n-modal-dialog-body>
        @if (isTransparent) {
          <p class="c11n-text-md c11n-space-stack-2x">{{ content.modalText }}</p>
        }
        <div class="c11n-modal-dialog__content__buttons">
          <c11n-button
            [labelText]="isTransparent ? content.stay : content.yes"
            (clickEvent)="isTransparent ? closeQuitModalButton() : yesQuitButton()"
            data-btn="dialog-content-button"
            data-cy="quit-modal-yes-button">
          </c11n-button>
          <c11n-button
            [labelText]="isTransparent ? content.quit : content.no" variant="secondary"
            (clickEvent)="isTransparent ? yesQuitButton() : closeQuitModalButton()"
            data-btn="dialog-content-button"
            data-cy="quit-modal-no-button">
          </c11n-button>
        </div>
      </div>
    </c11n-modal-dialog>

    <c11n-modal-dialog
      #saveAndQuitModal modalId="save-and-quit"
      [headingText]="content.saveAndQuit.modalHeader"
      [maxWidth]="660"
      (closeEvent)="closeSaveAndQuitModalIcon()">
      <div c11n-modal-dialog-body>
          @let sq = content.saveAndQuit;
          <p class="c11n-text-md c11n-space-stack-2x">
            {{ sq.startingWord }}
            <strong>{{ sq.saveAndQuitButtonLabel }}</strong>
            {{ sq.modalText }}
            <strong>{{ currentDate | date: 'MMMM d, y' }}</strong>
            {{ sq.modalTextBeforeLink }}
            <button c11n-link (click)="startOverButtonClick()">{{ sq.startOverLinkLabel }}</button>
            {{ sq.modalTextAfterLink }}
          </p>
          <p class="c11n-text-md c11n-space-stack-2x">{{ sq.modalText2 }}</p>
        <div class="c11n-modal-dialog__content__buttons">
          <c11n-button
            [labelText]="sq.saveAndQuitButtonLabel"
            (clickEvent)="closeSaveAndQuitModalButton()"
            data-btn="dialog-content-button"
            data-cy="save-and-quit-modal-save-and-quit-button">
          </c11n-button>
          <c11n-button
            variant="secondary"
            [labelText]="sq.deleteDraftButtonLabel"
            (clickEvent)="deleteDraftButton()"
            data-btn="dialog-content-button"
            data-cy="save-and-quit-modal-delete-draft-button">
          </c11n-button>
        </div>
      </div>
    </c11n-modal-dialog>
  </div>
}
